import {
    Button,
    chakra,
    Flex,
    Box
} from '@chakra-ui/react';

export const Content = chakra(Flex, {
    baseStyle: {
        flexDirection: 'column',
        justifyContent: 'center',
        flexGrow: 1,
        alignSelf: 'center',
        maxW: '960px',
        m: 'auto',
        backgroundColor: 'neutral.100'
    }
});

export const BadgeContainer = chakra(Flex, {
    baseStyle: {
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: '25px'
    }
});

export const ButtonWrapper = chakra(Box, {
    baseStyle: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '28px',
        marginTop: '12px',
        width: '95%'
    }
});

export const CompareTheseFeatures = chakra(Button, {
    baseStyle: {
        w: 260,
        h: 50,
        ['svg, svg path']: {
            ['fill']: 'var(--3p-colors-primary-50) !important',
            ['stroke']: 'var(--3p-colors-primary-50) !important'
        }
    }
});
